import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { getSettings, SettingsResponse } from "../services/settings";
import { useToast } from "../hooks/useToast";
import GlobalLoader from "../components/ui/GlobalLoader";

export type SettingsOutletContextType = {
  settingsData: SettingsResponse["data"] | null;
  loadingSettings: boolean;
  refreshSettings: () => Promise<void>;
};

const Settings = () => {
  const toast = useToast();
  const { user } = useAuth();
  const [settingsData, setSettingsData] = useState<SettingsResponse["data"] | null>(null);
  const [loadingSettings, setLoadingSettings] = useState(true);

  const fetchSettings = async (force: boolean = false) => {
    if (!settingsData || force)
      setLoadingSettings(true);
    try {
      const response = await getSettings(force);
      if (response.success) {
        setSettingsData(response.data);
      }
    } catch (error: any) {
      console.error("Failed to fetch settings:", error);
      toast.error("Could not load settings. Please check your connection and try again.");
    } finally {
      setLoadingSettings(false);
    }
  };

  React.useEffect(() => {
    fetchSettings();
  }, []);

  if (loadingSettings || !settingsData) {
    return (
      <div className="flex items-center justify-center p-12 min-h-[400px]">
        <GlobalLoader
          initialPageLoad={false}
          description="Loading settings..."
          compensateSidebar={false}
        />
      </div>
    );
  }

  return (
    <div className="overflow-x-hidden">
      <div className="space-y-6">
        <div className="px-2 md:px-3">
          <Outlet context={{ settingsData, loadingSettings, refreshSettings: () => fetchSettings(true) } satisfies SettingsOutletContextType} />
        </div>
      </div>

    </div>
  );
};

export default Settings;
